import type { IChat } from '@/modules/chat-matrix-fast/types/IChat'
import { getCachedMatrixPresence } from '@/modules/chat-matrix-fast/services/matrixPresenceService'
import { resolveDialogPeerMxid } from '@/modules/chat-matrix-fast/utils/dialogPresence'

export function resolveChatOnlineStatus(
  chat: Pick<IChat, 'type' | 'matrix_peer_id' | 'dialog_member' | 'online'>,
): boolean {
  const mxid = resolveDialogPeerMxid(chat)
  if (mxid) {
    const cached = getCachedMatrixPresence(mxid)
    if (cached !== undefined) {
      return cached
    }
  }

  return chat.online === true
}
